module.exports = __webpack_public_path__ + "p8_img2.jpg?67436f1d1a710d4be98ec42f7262e34a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p8/p8_img2.jpg
// module id = 133
// module chunks = 0